export default Object.freeze({
    PROPERTY_INFO: 1,
    TAXES_ASSESMENTS: 2,
    RESTRICTIVE_COVENANTS: 3,
    RECORDED_PLAT: 4,
    LIENS: 5,
    EASEMENTS: 6,
    TITLE_INSURANCE_APPLICATION: 7,
    ADDITIONAL_INFO: 8,
    REVIEW_PTO: 9
});